<template>
  <div class="v-table-tr">
    <div @click="newRow" class="v-table-tr-plus"><i class="fa fa-plus-circle"></i></div>
    <v-table-code ref="codeRef"
                     :voucherDetailList="voucherDetailList"
                     :rowIndex="rowIndex"/>
    <v-table-summary ref="summaryRef"
                     :summary="voucherDetail.summary"
                     :detail="voucherDetail"
                     :voucherDetailList="voucherDetailList"
                     :rowIndex="rowIndex"/>
    <v-table-subject ref="subjectRef"
                      @childNewSubject="newSubject"
                     :rowOperate="rowOperate" 
                     :voucherDate="voucherDate"
                     @updateParentData="updateParentData"
                     :subjectList="subjectList"
                     :subjectMap="subjectMap"
                     :subject="voucherDetail.subject"
                     :auxiliary="voucherDetail.auxiliary"
                     :detail="voucherDetail"
                     :rowIndex="rowIndex"/>
    <v-table-debit ref="debitRef" :detail="voucherDetail" :debit="voucherDetail.debitAmount" :rowIndex="rowIndex"/>
    <v-table-credit ref="creditRef" :detail="voucherDetail" :credit="voucherDetail.creditAmount" :rowIndex="rowIndex"/>
    <div @click="rmRow" class="v-table-tr-minus"><i class="fa fa-minus-circle"></i></div>
  </div>
</template>

<script setup>
import VTableCode from "@components/VoucherTable/VTableCode.vue";
import VTableSummary from "@components/VoucherTable/VTableSummary.vue";
import VTableSubject from "@components/VoucherTable/VTableSubject.vue";
import VTableDebit from "@components/VoucherTable/VTableDebit.vue";
import VTableCredit from "@components/VoucherTable/VTableCredit.vue";
import {getCurrentInstance, onMounted, ref,watch} from "vue";
import {getVTable} from "@components/VoucherTable/VtUtil";

const props = defineProps(['voucherDetail', 'rowIndex', 'subjectList', 'subjectMap',"voucherDetailList","rowOperate","voucherDate"]);



const codeRef = ref(null);
const summaryRef = ref(null);
const subjectRef = ref(null);
const debitRef = ref(null);
const creditRef = ref(null);
let VTableTr = null;
const emits = defineEmits(['update',"childNewSubject",'updateParentData']);

const newRow = () => {
  VTableTr.exposed.newRow(props.rowIndex);
}

const rmRow = () => {
  VTableTr.exposed.rmRow(props.rowIndex);
}

const updateParentData = (newValue) => {  
  console.log("我收到了")
  emits('updateParentData', "false");//向父组件VTableTr发送数据
}  

//jxd接收子组件的VTableSubject添加科目成功的信息
const newSubject = (data) => {
  console.log(data)
  emits('childNewSubject', data);//向父组件VTable发送添加科目成功事件
}

onMounted(() => {
  VTableTr = getVTable(getCurrentInstance());
  VTableTr.exposed.pushColInstance(props.rowIndex, {
    summary: summaryRef.value,
    subject: subjectRef.value,
    debitAmount: debitRef.value,
    creditAmount: creditRef.value
  });
})
</script>

<style scoped lang="less">
.v-table {
  &-tr {
    height: 70px;
    border-bottom: @border;
    display: flex;
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    &-plus, &-minus {
      display: none;
      position: absolute;
      font-size: 18px;
      cursor: pointer;
      top: 18px;
    }

    &-plus {
      left: -16px;
      color: @green-color;
    }

    &-minus {
      right: -16px;
      color: @red-color;
    }

    &:hover {
      .v-table-tr-plus, .v-table-tr-minus {
        display: inline-block;
      }
    }
  }
}
</style>
